import * as React from 'react';
import { Component, CSSProperties, ReactNode } from 'react';
import * as classNames from 'classnames';

if (process.env.BROWSER) {
  require('./index.less');
}

import {
  INewsItem,
} from '../model';
import {
  NewsStyleType,
  INewsConfig,
} from '../model/config';

import {
  getDomNewsMeta,
} from '../util/dom';
import {openNewsWithArticle} from '../../../../common/openArticle';

interface IComponentProps {
  className?: string;
  style?: CSSProperties;
  isRTL: boolean;
  news: INewsItem;
  onClick?: () => void;
}
interface IComponentState {}

export default class ItemCommon extends Component<IComponentProps, IComponentState> {
  constructor(props) {
    super(props);
    this.state = {};
    [
      'handleOnClick',
      'getDomDetail',
      'getDomImgContainer',
    ].forEach((actionName: string) => {
      this[actionName] = this[actionName].bind(this);
    });
  }

  public render(): ReactNode {
    const classesRoot: string = classNames('news-box', 'news-item', 'news-item-common', this.props.className);
    const domDetail: ReactNode = this.getDomDetail();
    const domImgContainer: ReactNode = this.getDomImgContainer();
    return (
      <a className={classesRoot} style={this.props.style}
      onClick={(e) => this.handleOnClick(e)}
      href="#"
      >
        { domDetail }
        { domImgContainer }
      </a>
    );
  }

  public handleOnClick(e): boolean {
    e.preventDefault();
    const news: INewsItem = this.props.news;
    if (this.props.onClick) {
      this.props.onClick();
    }
    return false;
  }

  public getDomDetail(): ReactNode {
    const news: INewsItem = this.props.news;
    const classesTitle: string = classNames('news-item-title', 'news-item-common-title', {
      'news-item-title-rtl': this.props.isRTL,
    });
    const classesMeta: string = classNames('news-item-meta', 'news-item-common-meta', {
      'news-item-meta-rtl': this.props.isRTL,
    });
    const domTitle: ReactNode = (
      <div className={ classesTitle }>{ news.title }</div>
    );
    const domMetaFragment: ReactNode = getDomNewsMeta(news);
    const domMeta: ReactNode = (
      <div className={ classesMeta }>{ domMetaFragment }</div>
    );
    return (
      <div className={'news-item-common-left'}>
        { domTitle }
        { domMeta }
      </div>
    );
  }

  public getDomImgContainer(): ReactNode {
    const news: INewsItem = this.props.news;
    let domImgContainer: ReactNode = null;
    if (news.thumbnails === undefined || news.thumbnails === null || news.thumbnails.length === 0) {
      return domImgContainer;
    }
    let domImg: ReactNode = null;
    domImg = (
      <img src={ news.thumbnails[0].url } />
    );
    domImgContainer = (
      <div className={'news-item-common-imgContainer'}>
        { domImg }
      </div>
    );
    return domImgContainer;
  }

}
